export default "__VITE_ASSET__I7OxkGWx__"